export default {
    methods: {
        calculateSchoolFees(school, application) {
            let promo = 0;
            if (application) {
                if (application.promoCodes && application.promoCodes.length) {
                    const promoCode = application.promoCodes[0];
                    if (promoCode.valueType === 'amount') {
                        promo = promoCode.value;
                    } else if (promoCode.valueType === 'percentage') {
                        if (school) {
                            let feesReduction = (school.application_fees * promoCode.value) / 100;
                            promo = Math.round(feesReduction * 2) / 2;
                        }
                    }
                }
            }
            let finalFees = school ? (school.application_fees - promo) : null;
            if (finalFees < 0) {
                finalFees = 0;
            }
            return finalFees;
        },
        getSchoolObject(school) {
            if (typeof school === 'string') {
                return this.schoolChoice(school);
            }
            return school;
        }
    },
    computed: {
        schoolFees() {
            const school = this.getSchoolObject(this.school);
            return this.calculateSchoolFees(school, this.application);
        }
    }
};
